"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UploadcareFile_1 = require("../tools/UploadcareFile");
var info_1 = require("../api/info");
var uploadFromUploaded = function (uuid, _a) {
    var publicKey = _a.publicKey, fileName = _a.fileName, baseURL = _a.baseURL, cancel = _a.cancel, onProgress = _a.onProgress, source = _a.source, integration = _a.integration, retryThrottledRequestMaxTimes = _a.retryThrottledRequestMaxTimes, baseCDN = _a.baseCDN;
    return info_1.default(uuid, {
        publicKey: publicKey,
        baseURL: baseURL,
        cancel: cancel,
        source: source,
        integration: integration,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes
    })
        .then(function (fileInfo) { return new UploadcareFile_1.UploadcareFile(fileInfo, { baseCDN: baseCDN, fileName: fileName }); })
        .then(function (result) {
        // hack for node ¯\_(ツ)_/¯
        if (onProgress)
            onProgress({ value: 1 });
        return result;
    });
};
exports.default = uploadFromUploaded;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/upload-client/lib/uploadFile/uploadFromUploaded.js
// module id = 1258
// module chunks = 71